





































































































































































































































































































import { Component, Watch } from 'vue-property-decorator'
import GlobalMixins from '../mixins'
import { IResult, IPartyStatement, IParty } from '../interfaces'
import AppError from '@/components/AppError.vue'

@Component({
	components: {
		AppError
	}
})
export default class Results extends GlobalMixins {
	circleGraphWidth: {desktop: number, mobile: number} = {
		desktop: 160,
		mobile: 100
	} 
	circleGraphStroke: {desktop: number, mobile: number} = {
		desktop: 20,
		mobile: 12
	}
	circleGraphPercentages: [number, number, number] = [0, 0, 0]
	delayPerResult: number = .15
	preventAnimation: boolean = true
	resultInOverview: false | IResult = false
	lastResultInOverview: false | IResult = false
	resultsForShootout: IResult[] = []
	hideShootout: boolean = false
	shootoutSelectedParties: number[] = []
	showNoMatchesError: boolean = false
	rawFilteredResults: IResult[] = []
	lastUpdatePosition: number | undefined
	showNoMatchesWithCurrentSelectedError: boolean = false

	get filteredResults() {
		if ((!this.rawFilteredResults.length || !this.lastUpdatePosition) || (this.lastUpdatePosition !== this.updateCounter)) {
			this.rawFilteredResults = this.results(true)
			this.lastUpdatePosition = this.updateCounter
		}

		return this.rawFilteredResults
	}
	get tabIndex(): number {
		return (this.resultInOverview && this.$route.name === 'choices-overview') ? -1 : 0
	}
	get tabIndexResult(): number {
		if (!this.config.settings.showStatementOverview) return -1

		return (this.resultInOverview && this.$route.name === 'choices-overview') ? -1 : 0
	}
	get tabIndexShootoutButton(): number {
		if (this.resultInOverview && this.$route.name === 'choices-overview') return -1
		if (this.shootoutSelectedParties.length !== 2) return -1

		return 0
	}
	get shootoutResultsTitle(): string {
		if (this.shootoutResults === false) return ''

		if (this.shootoutResults[0].matches === this.shootoutResults[1].matches) {
			if (this.shootoutResults[0].matches === 0) {
				return this.dictionary.results.shootout.result.noPointsMessage
			} else {
				return this.dictionary.results.shootout.result.samePointsMessage
			}		
		}

		return `${this.dictionary.results.shootout.result.preCounter} <span>${this.shootoutResults[0].matches} ${this.dictionary.results.shootout.result.counterOf} ${this.shootoutStatements.length}</span> ${this.dictionary.results.shootout.result.postCounterPreParty} <span>${this.shootoutResults[0].party.name}</span>.`
	}
	get shootoutResultsTitleAriaLabel(): string {
		if (this.shootoutResults === false) return ''

		if (this.shootoutResults[0].matches === this.shootoutResults[1].matches) {
			if (this.shootoutResults[0].matches === 0) {
				return this.dictionary.results.shootout.result.noPointsMessage
			} else {
				return this.dictionary.results.shootout.result.samePointsMessage
			}		
		}

		return `${this.dictionary.results.shootout.result.preCounter} ${this.shootoutResults[0].matches} ${this.dictionary.results.shootout.result.counterOf} ${this.shootoutStatements.length} ${this.dictionary.results.shootout.result.postCounterPreParty} ${this.shootoutResults[0].party.name}.`
	}
	get showShootout(): boolean {
		if (!this.rawShootoutStatements.length) return false
		if (!this.config.settings.shootoutStatementMargin || this.config.settings.shootoutStatementMargin < 1) return false
		if (!this.config.settings.shootoutStatementAmount || this.config.settings.shootoutStatementAmount < 1) return false
		if (this.config.settings.shootoutMinimumStatementAmount && this.config.settings.shootoutStatementAmount < this.config.settings.shootoutMinimumStatementAmount) return false
		if (this.hideShootout) return false

		let maxDifference = Math.ceil((100 / this.maxScore) * this.config.settings.shootoutStatementMargin)
		let samePercentageResults: {percentage: number, index: number}[] = []
		let removeSameResults: boolean = false

		this.resultsForShootout = []

		this.filteredResults
			.slice(0, 5)
			.forEach((result, index) => {
				if (index === 0) {
					this.resultsForShootout.push(result)

					samePercentageResults.push({
						percentage: result.percentage,
						index
					})
				} else if (index === 4) {
					// AH, 100122: remove any parties with the same percentage at the end of the list, 
					// to avoid accidentally excluding a party with that same percentage from the shootout (i.e. the 6th result). 
					if (samePercentageResults[(samePercentageResults.length - 1)].percentage === result.percentage) removeSameResults = true
				} else {
					if ((this.resultsForShootout[0].percentage - result.percentage) <= maxDifference) {
						this.resultsForShootout.push(result)
						
						if (samePercentageResults[(samePercentageResults.length - 1)].percentage !== result.percentage) samePercentageResults = []

						samePercentageResults.push({
							percentage: result.percentage,
							index
						})
					}
				}
			})

		if (removeSameResults) {
			this.resultsForShootout.splice(samePercentageResults[0].index, (4 - samePercentageResults[0].index))
		}

		if (this.resultsForShootout.length > 1) {
			let shootoutPossible = false

			this.resultsForShootout.forEach(result => {
				this.resultsForShootout.forEach(secondResult => {
					if (result.party.id === secondResult.party.id) return

					if (this.$store.getters.shootoutStatements([result.party.id, secondResult.party.id]).length) shootoutPossible = true
				})
			})

			return shootoutPossible
		} else {
			return false
		}
	}
	get shootoutResults(): false | {
		party: IParty,
		percentage: number,
		matches: number
	}[] {
		if (!this.showShootout) return false
		if (this.shootoutStatements.length === 0 || (this.shootoutStatements.length !== this.user.shootoutChoices.length)) return false
		if (!this.$store.getters.showShootoutResults) return false

		return (this.user.shootoutParties as [number, number])
			.map(partyId => {
				let matches = 0
				const party = this.parties.filter(party => {
					return (partyId === party.id)
				})[0]

				this.shootoutStatements.forEach(statement => {
					const partyPosition = (party.shootoutStatements as IPartyStatement[])
						.filter(partyStatement => {
							return (partyStatement.id === statement.id)
						})[0].position
					const userChoice = this.user.shootoutChoices
						.filter(userChoice => {
							return (userChoice.originalStatementId === statement.id)
						})[0].choice

					if (partyPosition === userChoice) matches++
				})

				return {
					party,
					percentage: Math.round((100 / this.shootoutStatements.length) * matches),
					matches
				}
			})
			.sort((a, b) => {
				if (a.percentage === b.percentage) return 0
				if (a.percentage > b.percentage) return -1

				return 1
			})
	}

	@Watch('resultInOverview')
	onresultInOverviewChange() {
		if (this.resultInOverview) {
			this.$emit('preventScrolling')

			if (this.$route.name === 'results') {
				this.$router.push({
					name: 'choices-overview'
				})
			}
		} else {
			this.$emit('allowScrolling')
		}
	}
	@Watch('$route')
	onRouteChange() {
		if (this.$route.name === 'results') {
			if (this.resultInOverview) {	
				this.lastResultInOverview = this.resultInOverview
				this.resultInOverview = false
			}
		} else if (this.$route.name === 'choices-overview') {
			if (this.lastResultInOverview) {
				this.resultInOverview = this.lastResultInOverview
				this.lastResultInOverview = false
			} else if(!this.resultInOverview) { 
				this.$router.replace({
					name: 'results'
				})
			}
		}
	}
	@Watch('shootoutSelectedParties')
	onShootoutSelectedPartiesChange() {
		if (this.shootoutSelectedParties.length !== 2) {
			this.$store.dispatch('setShootoutParties', false)

			if (this.shootoutSelectedParties.length === 1) {
				let hasMatch = false

				this.resultsForShootout.forEach(result => {
					if (result.party.id === this.shootoutSelectedParties[0]) return

					if (this.$store.getters.shootoutStatements([this.shootoutSelectedParties[0], result.party.id]).length) hasMatch = true
				})

				if (!hasMatch) this.showNoMatchesError = true
			}
		}
	}

	tabIndexShootoutParty(partyId: number): number {
		if (this.resultInOverview && this.$route.name === 'choices-overview') return -1
		if (this.shootoutPartyDisabled(partyId)) return -1
		if (this.shootoutSelectedParties.length === 2 && this.shootoutSelectedParties.indexOf(partyId) === -1) return -1

		return 0
	}
	radius(size: 'desktop' | 'mobile'): number {
		return ((this.circleGraphWidth[size] - this.circleGraphStroke[size]) / 2)
	}
	circumference(size: 'desktop' | 'mobile'): number {
		return (2 * Math.PI * this.radius(size))
	}
	lightPartyColour(result: IResult): string | false {
		let hex = result.party.color ? result.party.color : false

		if (!hex) return false
		
		hex = hex.replace(/^\s*#|\s*$/g, '');
		
		if(hex.length == 3){
			hex = hex.replace(/(.)/g, '$1$1');
		}

		var r = parseInt(hex.substr(0, 2), 16),
			g = parseInt(hex.substr(2, 2), 16),
			b = parseInt(hex.substr(4, 2), 16);

		return '#' +
		((0|(1<<8) + r + (256 - r) * 80 / 100).toString(16)).substr(1) +
		((0|(1<<8) + g + (256 - g) * 80 / 100).toString(16)).substr(1) +
		((0|(1<<8) + b + (256 - b) * 80 / 100).toString(16)).substr(1);
	}
	openChoicesOverview(result: IResult): void {
		if (!this.config.settings.showStatementOverview) return
		
		this.lastResultInOverview = false
		this.selectParty(result);		
	}
	closeChoicesOverview(): void {
		this.lastResultInOverview = this.resultInOverview
		this.resultInOverview = false
		
		this.$router.push({
			name: 'results'
		})
	}
	updateResults(): void {
		this.updateCounter++
		
		this.setTop3()
	}
	setTop3(): void {
		this.circleGraphPercentages = (this.filteredResults.slice(0, 3).map(result => result.percentage) as [number, number, number])
	}
	selectParty(result: IResult) {
		this.resultInOverview = result;
		this.trackGAEvent('results-party');
	}
	toggleForShootout(partyId: number) {
		if (this.shootoutSelectedParties.indexOf(partyId) === -1) {
			if (this.shootoutSelectedParties.length !== 2 && !this.shootoutPartyDisabled(partyId)) {
				this.shootoutSelectedParties.push(partyId)
			} else if(this.shootoutSelectedParties.length !== 2 && this.shootoutPartyDisabled(partyId)) {
				this.showNoMatchesWithCurrentSelectedError = true
			}
		} else {
			this.shootoutSelectedParties.splice(this.shootoutSelectedParties.indexOf(partyId), 1)
		}
	}
	startShootout() {
		if (this.shootoutSelectedParties.length !== 2) return

		this.$store.dispatch('setShootoutParties', this.shootoutSelectedParties)

		if (this.shootoutStatements.length) {
			this.trackGAEvent('results-shootout-start')

			this.$router.push({
				name: 'shootout-statement',
				params: {
					id: '1',
					title: this.slugify(this.statementTitleToString(this.shootoutStatements[0].title))
				} 
			})
		} else {
			return
		}
	}
	shootoutPartyDisabled(partyId: number): boolean {
		if (this.shootoutSelectedParties.indexOf(partyId) === -1 && this.shootoutSelectedParties.length === 2) return true
		if (this.shootoutSelectedParties.length === 1 && this.shootoutSelectedParties[0] !== partyId) {
			if (this.$store.getters.shootoutStatements([this.shootoutSelectedParties[0], partyId]).length === 0) return true
		}

		return false
	}
	resetShootout() {
		this.$store.dispatch('setShootoutParties', false)

		this.shootoutSelectedParties = []
		this.showNoMatchesError = false
	}

	created() {
		setTimeout(() => {
			this.preventAnimation = false

			this.setTop3()
		}, 50)

        if (this.showShootout && this.resultsForShootout.length == 2)
            this.resultsForShootout.forEach(result=> this.toggleForShootout(result.party.id))

		else if (this.user.shootoutParties !== false && this.user.shootoutParties.length === 2) {
			this.shootoutSelectedParties = this.user.shootoutParties
		}
	}
}
